import { render, staticRenderFns } from "./_token.vue?vue&type=template&id=eb48a036"
import script from "./_token.vue?vue&type=script&lang=js"
export * from "./_token.vue?vue&type=script&lang=js"
import style0 from "./_token.vue?vue&type=style&index=0&id=eb48a036&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports